import { logOutCustomer } from "@/redux/slices/customerAuthSlice";
import { fetchBaseQuery, createApi } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  baseUrl: `${import.meta.env.VITE_API_BASE_URL}/api`,
  prepareHeaders: (headers, { getState }) => {
    // 1. Try getting token from Redux State first
    let token = getState().customerAuth?.token;

    // 2. CRITICAL FALLBACK: If Redux is empty, check LocalStorage
    // This fixes the 401 error on page reload
    if (!token) {
      // Check the new key first
      const storedCustomerData = localStorage.getItem("customerAuthData");
      if (storedCustomerData) {
        try {
          const parsed = JSON.parse(storedCustomerData);
          token = parsed.access_token || parsed.token;
        } catch (e) {
          console.error("Error parsing customerAuthData", e);
        }
      }

      // Check the old key as a backup
      if (!token) {
        const storedOldData = localStorage.getItem("authUser");
        if (storedOldData) {
          try {
            const parsed = JSON.parse(storedOldData);
            token = parsed.access_token || parsed.token;
          } catch (e) {
            console.error("Error parsing authUser", e);
          }
        }
      }
    }

    // 3. Inject the Token into the Header
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    headers.set("Accept", "application/json");
    return headers;
  },
});

// 4. Wrapper to handle Token Expiration (401)
const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    // Only log out if the API explicitly says the token is invalid
    console.warn("Token expired or invalid. Logging out...");
    api.dispatch(logOutCustomer());
  }
  return result;
};

export const apiSlice = createApi({
  reducerPath: "customerApi",
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
  tagTypes: ["User", "Order", "Payment", "Cart", "cateringEvent"],
});
